import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../Layout/Layout";
import { useNavigate } from "react-router-dom";
import LoaderSmall from "../../Components/LoaderSmall";
import { getCurrentDate } from "../../common/Validations";
import DatePickerComponent from "./Charts/FilterComponent/DatePickerComponent";
import SupplierConstants from "../../common/SupplierConstants";
import CategoryCard from "../../Components/Cards/CategoryCard";
import ItemService3 from "../../services/ap_auto_appCommonService";
import CollapseCard from "../../Components/Collapsecard/Collapsecard";
import HrColumnChart from "../hr_app/Charts/HrColumnChart";
const Dashboard = () => {
  localStorage.setItem("menu", "Dashboard");
  localStorage.setItem("submenu", "-");
  const navigate = useNavigate();

  const navigateToMainPage = (page) => {
    if (page === "supplier") {
      navigate(SupplierConstants.SUPPILER_LIST);
    } else if (page === "users") {
      navigate(SupplierConstants.ADMIN_MANAGE_USER_LIST);
    } else if (page === "pr") {
      navigate(SupplierConstants.SOURCING_PURCHASE_REQUISITION_LIST);
    } else if (page === "po") {
      navigate(SupplierConstants.POCOLLABRATION_PURCHASE_ORDER_LIST);
    } else if (page === "qtn") {
      navigate(SupplierConstants.SOURCING_BUYER_QUOTATION_LIST);
    }
  };

  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = String(today.getMonth() + 1).padStart(2, "0");
  const [filterShow, setFilterShow] = useState(false);
  const [moduleStats, setModuleStats] = useState({});
  console.log(">>>moduleStats", moduleStats);
  const [moduleStatsLoading, setModuleStatsLoading] = useState(true);
  //   try {
  //     setModuleStatsLoading(true);

  //     const payload = {
  //       dashboard: "hr_module",
  //       chartFilterType: "Yearly",
  //       chartInput2: new Date().getFullYear(),
  //     };
  //     const res = await ItemService3.getModuleStats(payload);
  //     if (res?.status === 200) {
  //       setModuleStats(res?.data?.data || res?.data || {});
  //     }
  //   } catch (err) {
  //     console.error("Failed to load module stats", err);
  //     toast.error("Failed to load dashboard data");
  //   } finally {
  //     setModuleStatsLoading(false);
  //   }
  // };
  const loadModuleStats = async (filter) => {
    try {
      setModuleStatsLoading(true);

      const payload = buildModuleStatsPayload(filter);

      const res = await ItemService3.getModuleStats(payload);
      if (res?.status === 200) {
        setModuleStats(res?.data?.data || res?.data || {});
      }
    } catch (err) {
      console.error("Failed to load module stats", err);
      toast.error("Failed to load dashboard data");
    } finally {
      setModuleStatsLoading(false);
    }
  };

  useEffect(() => {
    loadModuleStats({
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getChartData = (moduleName) => {
    const chart = moduleStats?.[moduleName]?.chart;
    return {
      categories: chart?.categories || [],
      series: chart?.series || [],
    };
  };
  const taskChart = getChartData("task");
  const clientChart = getChartData("client");
  const projectChart = getChartData("project");
  const employeeChart = getChartData("employee");
  const attendancehart = getChartData("attendance");

  const buildModuleStatsPayload = (filter = {}) => {
    const action = filter.action || "Monthly";

    const payload = {
      dashboard: "hr_module",
      chartFilterType: action, // "Monthly" | "Yearly" | "Custom"
    };

    if (action === "Yearly") {
      payload.chartInput2 = Number(filter.year) || currentYear;
    } else if (action === "Monthly") {
      payload.chartInput1 = Number(filter.month) || Number(currentMonth); // month number
      payload.chartInput2 = Number(filter.year) || currentYear;
    } else if (action === "Custom") {
      payload.chartInputFrom = filter.fromDate;
      payload.chartInputTo = filter.toDate;
    }

    return payload;
  };
  // On Filtered Data
  const handleFilterData = async (filter) => {
    // console.log(">> filter", filter)
    await loadModuleStats(filter);
  };

  useEffect(() => {
    let defaultFilter = {
      action: "Monthly",
      month: currentMonth,
      year: currentYear,
    };

    loadModuleStats(defaultFilter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const categoryConfigs = [
    {
      title: "Employee",
      icon: "bi bi-people",
      navigateKey: "employee",
      directCount: moduleStats?.employee?.total ?? 0,
      value: moduleStats?.employee?.sum ?? 0,
    },
    {
      title: "HR Documents",
      icon: "bi bi-file-earmark-text",
      navigateKey: "hrDoc",
      directCount: moduleStats?.hrDoc?.total ?? 0,
      value: moduleStats?.hrDoc?.sum ?? 0,
    },
    {
      title: "Tasks",
      icon: "bi bi-list-task",
      navigateKey: "task",
      directCount: moduleStats?.task?.total ?? 0,
      value: moduleStats?.task?.sum ?? 0,
    },
    {
      title: "Attendance",
      icon: "bi bi-calendar-check",
      navigateKey: "attendance",
      directCount: moduleStats?.attendance?.total ?? 0,
      value: moduleStats?.attendance?.sum ?? 0,
    },
    {
      title: "Expenses",
      icon: "bi bi-cash-stack",
      navigateKey: "expenses",
      directCount: moduleStats?.expenses?.total ?? 0,
      value: moduleStats?.expenses?.sum ?? 0,
    },
    {
      title: "Clients",
      icon: "bi bi-person-badge",
      navigateKey: "client",
      directCount: moduleStats?.client?.total ?? 0,
      value: moduleStats?.client?.sum ?? 0,
    },
    {
      title: "Projects",
      icon: "bi bi-kanban",
      navigateKey: "project",
      directCount: moduleStats?.project?.total ?? 0,
      value: moduleStats?.project?.sum ?? 0,
    },
  ];
  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            {/* HEADER */}
            <Row>
              <Col xs={10} md={10}>
                <h2 className="mainTitle">
                  Assest Dashboard -
                  <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                    {getCurrentDate()}
                  </span>
                </h2>

                <p className="subText my-0">Dashboard detailed page</p>
              </Col>

              <Col xs={2} md={2}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>

            <hr />

            {/* FILTER */}
            {filterShow && (
              <DatePickerComponent
                getfiltereddata={handleFilterData}
                cancelAction={() => setFilterShow(!filterShow)}
              />
            )}
            <section className="section">
              <div className="col-lg-12 commTopButtonRightLeftPadding">
                <CollapseCard title="">
                  <div className="row g-3">
                    {categoryConfigs.map((item, index) => (
                      <div
                        className="col-12 col-md-6 col-lg-3 px-2"
                        key={index}
                      >
                        <CategoryCard
                          {...item}
                          onClick={() => navigateToMainPage(item.navigateKey)}
                        />
                      </div>
                    ))}
                  </div>
                </CollapseCard>
              </div>
              <div className="col-lg-12 commTopButtonRightLeftPadding">
                <CollapseCard title="Employee Statics">
                  {/* <h5 className="card-title">Employee</h5> */}

                  <LoaderSmall isLoading={moduleStatsLoading} />

                  {!moduleStatsLoading && (
                    <HrColumnChart chartdata={employeeChart} />
                  )}
                </CollapseCard>
              </div>
              <div className="col-lg-12 commTopButtonRightLeftPadding">
                <CollapseCard title="Attendance Statics">
                  {/* <h5 className="card-title">Attendance</h5> */}
                  <LoaderSmall isLoading={moduleStatsLoading} />
                  {!moduleStatsLoading && (
                    <HrColumnChart chartdata={attendancehart} />
                  )}
                </CollapseCard>
              </div>

              <div className="col-lg-12 commTopButtonRightLeftPadding">
                <CollapseCard title="Client Statics">
                  {/* <h5 className="card-title">Client</h5> */}

                  <LoaderSmall isLoading={moduleStatsLoading} />

                  {!moduleStatsLoading && (
                    <HrColumnChart chartdata={clientChart} />
                  )}
                </CollapseCard>
              </div>

              <div className="col-lg-12 commTopButtonRightLeftPadding">
                <CollapseCard title="Project Statics">
                  {/* <h5 className="card-title">Project</h5> */}

                  <LoaderSmall isLoading={moduleStatsLoading} />

                  {!moduleStatsLoading && (
                    <HrColumnChart chartdata={projectChart} />
                  )}
                </CollapseCard>
              </div>
              <div className="col-lg-12 commTopButtonRightLeftPadding">
                <CollapseCard title="Task Statics">
                  {/* <h5 className="card-title">Task</h5> */}

                  <LoaderSmall isLoading={moduleStatsLoading} />

                  {!moduleStatsLoading && (
                    <HrColumnChart chartdata={taskChart} />
                  )}
                </CollapseCard>
              </div>
            </section>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default Dashboard;
